import { CapacitorHttp, HttpOptions, HttpResponse } from "@capacitor/core";

import { toNetworkError } from "@bitwarden/common/models/response/error.response";

type capHttpResponse<T> = Omit<HttpResponse, "data"> & { data: T };

export const capFetch = async <T = any>(request: HttpOptions): Promise<capHttpResponse<T>> => {
  return await CapacitorHttp.request(request).catch(toNetworkError);
};

export const nativeFetch = fetch;

export class FetchError extends Error {
  constructor(
    public message: string,
    public data: any,
  ) {
    super(message);
    this.name = "FetchError";
  }
}
